<template>
    <v-card class="end-campaign-card">
        <!-- Confirmation Step -->
        <v-card-text v-if="!isComplete" class="pa-6 pa-md-8">
            <div class="text-center">
                <v-icon size="56" color="warning" class="mb-4">mdi-cash-check</v-icon>
                <h2 class="modal-title mb-3">Claim Your Funds</h2>

                <v-card elevation="0" color="#f8f9fa" class="pa-4 mb-4 amount-card">
                    <p class="amount-label mb-3">Amount raised</p>
                    <p class="amount-value">${{ totalRaised.toFixed(2) }}</p>
                </v-card>

                <p class="info-text mb-4">
                    By claiming your funds, your campaign will end and you will no longer be able to receive donations.
                </p>

                <p class="info-text mb-6">
                    Your funds will be transferred to your connected bank account within <strong>5 business days</strong>.
                </p>

                <v-btn
                    color="primary"
                    @click="claimFunds"
                    :loading="isCallingApi"
                    depressed
                    block
                    large
                    class="mb-3"
                >
                    Confirm & Claim Funds
                </v-btn>
                <v-btn
                    text
                    color="grey darken-1"
                    @click="$emit('hideDialog')"
                    block
                >
                    Cancel
                </v-btn>
            </div>
        </v-card-text>

        <!-- Success Step -->
        <v-card-text v-else class="pa-6 pa-md-8">
            <div class="text-center">
                <v-icon size="64" color="success" class="mb-4">mdi-check-circle</v-icon>
                <h2 class="modal-title mb-3">Your money is on the way!</h2>

                <p class="info-text mb-2">
                    We're processing your transfer of <strong>${{ totalRaised.toFixed(2) }}</strong>.
                </p>
                <p class="info-text mb-6">
                    Your funds will be deposited to your bank account within 5 business days.
                </p>

                <v-btn
                    color="primary"
                    @click="close"
                    depressed
                    block
                    large
                >
                    Done
                </v-btn>
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
    import UserService from "../services/user.service";
    import confetti from "canvas-confetti";

    export default {
        name: 'EndCampaign',
        props: ['campaign'],
        data() {
          return {
              isCallingApi: false,
              isComplete: false
          }
        },
        computed: {
            user() {
                return this.$store.getters.getUser;
            },
            totalRaised() {
                if (!this.campaign?.donations) return 0
                const totalCents = this.campaign.donations.reduce((sum, d) => sum + Number(d.amount || 0), 0)
                return totalCents / 100
            }
        },
        methods: {
            async claimFunds() {
                this.isCallingApi = true;
                await UserService.updateCampaign(this.campaign.id, {campaign: {is_ended: 1}});
                this.isCallingApi = false;
                this.isComplete = true;
                this.celebrateSuccess();
            },
            celebrateSuccess() {
                // Fire confetti from both sides
                const duration = 3000;
                const end = Date.now() + duration;

                const frame = () => {
                    confetti({
                        particleCount: 3,
                        angle: 60,
                        spread: 55,
                        origin: { x: 0, y: 0.7 },
                        colors: ['#40B771', '#1976d2', '#FFD700']
                    });
                    confetti({
                        particleCount: 3,
                        angle: 120,
                        spread: 55,
                        origin: { x: 1, y: 0.7 },
                        colors: ['#40B771', '#1976d2', '#FFD700']
                    });

                    if (Date.now() < end) {
                        requestAnimationFrame(frame);
                    }
                };
                frame();

                // Also fire a burst from center
                setTimeout(() => {
                    confetti({
                        particleCount: 100,
                        spread: 70,
                        origin: { y: 0.6 },
                        colors: ['#40B771', '#1976d2', '#FFD700', '#FF6B6B']
                    });
                }, 300);
            },
            close() {
                this.isComplete = false;
                this.$emit('getCampaign');
                this.$emit('hideDialog');
            }
        }
    }
</script>

<style scoped>
.end-campaign-card {
    border-radius: 12px !important;
}

.modal-title {
    font-size: 24px;
    font-weight: 700;
    color: #333;
}

.amount-card {
    border-radius: 10px !important;
}

.amount-label {
    font-size: 14px;
    color: #666;
    margin: 0;
}

.amount-value {
    font-size: 32px;
    font-weight: 700;
    color: #333;
    margin: 0;
}

.info-text {
    font-size: 15px;
    color: #555;
    line-height: 1.5;
}
</style>
